import { useState } from "react";
import { useNavigate } from "react-router-dom";

import ResetPasswordForm from "@/components/auth/ResetPasswordForm";
import { authService } from "@/services/authService";
import { TokenResetPasswordData } from "@/types/auth";

export default function ResetPasswordPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<null | string>(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async (data: TokenResetPasswordData) => {
    try {
      setIsLoading(true);
      setError(null);

      // Use real API to update password with token
      const response = await authService.updatePassword(
        data.token,
        data.password,
        data.confirmPassword,
      );

      if (response.success) {
        console.log("Password reset successful with token:", data.token);
        setIsSuccess(true);

        // Redirect to login after a delay
        setTimeout(() => {
          navigate("/auth/login");
        }, 3000);
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      setError(
        error instanceof Error ? error.message : "Failed to reset password",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ResetPasswordForm
      error={error || undefined}
      isLoading={isLoading}
      isSuccess={isSuccess}
      onSubmit={handleResetPassword}
    />
  );
}
